import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {IonicModule} from '@ionic/angular';

import {EinstellungenPage} from './einstellungen.page';
import {StoreModule} from '@ngrx/store';
import {reducers} from './einstellungen.reducer';
import {EffectsModule} from '@ngrx/effects';
import {EinstellungenPageUiEffects} from './einstellungen.effects.ui';
import {NotificationService} from '@orga-app/providers/notification.service';
import {SopiScrollModule} from '../../sopi/components/sopi-scroll/sopi-scroll.module';
import {SopiComponentsModule} from '../shared/sopi-components/sopi-components.module';
import {BenutzerverwaltungBenutzerEinstellungenAdminEffects, BenutzerverwaltungBenutzerIncidentManagementSichtbarkeitAdminEffects, BenutzerverwaltungBenutzerListeEffects, BenutzerverwaltungBenutzerTroubleTicketsSichtbarkeitAdminEffects} from '../../client-ngrx/benutzerverwaltung';
import {EinstellungenPageWsEffects} from './einstellungen.effects.ws';

const routes: Routes = [
    {
        path: '',
        component: EinstellungenPage,
        data: {title: 'Einstellungen'}
    }
];

@NgModule({
    declarations: [
        EinstellungenPage,
    ],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        StoreModule.forFeature('EinstellungenPage', reducers),
        EffectsModule.forFeature([
            EinstellungenPageUiEffects,
            EinstellungenPageWsEffects,
            BenutzerverwaltungBenutzerListeEffects,
            BenutzerverwaltungBenutzerEinstellungenAdminEffects,

            BenutzerverwaltungBenutzerTroubleTicketsSichtbarkeitAdminEffects,
            BenutzerverwaltungBenutzerIncidentManagementSichtbarkeitAdminEffects
        ]),
        SopiScrollModule,
        SopiComponentsModule.forRoot()
    ],
    providers: [
        NotificationService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EinstellungenPageModule {
}
